import { useQuery } from '@tanstack/react-query';
import axios from 'axios';

const fetchTotal = async () => {
  const { data } = await axios.get('/api/analytics/total');
  return data;
};

const fetchPage = async (path: string) => {
  const { data } = await axios.get(`/api/analytics/page?path=${encodeURIComponent(path)}`);
  return data;
};

export const useAnalyticsTotal = () => {
  const { data, isLoading, error } = useQuery({
    queryKey: ['analytics', 'total'],
    queryFn: fetchTotal,
    refetchInterval: 60000,
    staleTime: 60000,
  });

  return {
    total: data?.total,
    isLoading,
    error,
  };
};

export const useAnalyticsPage = (path: string) => {
  const { data, isLoading, error } = useQuery({
    queryKey: ['analytics', 'page', path],
    queryFn: () => fetchPage(path),
    enabled: !!path,
    staleTime: 60000,
  });

  return {
    visits: data?.visits,
    isLoading,
    error,
  };
};
